<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >   
        <CForm>
            
            <CRow>
              <CCol md="8">
                <CInput
                  label="Nombre:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="4">
                <CSelect
                  label="Proveedor: "
                  :value.sync="$v.form.provider_id.$model"
                  :options="providersOptions"
                  :isValid="checkIfValid('provider_id')"
                  invalidFeedback="Este campo es requerido."
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <br />
                <CInput
                  label="Correo Electrónico (Usuario):"
                  :lazy="false"
                  :value.sync="$v.form.email.$model"
                  :isValid="checkIfValid('email')"
                  placeholder=""
                  autocomplete="given-email"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
            </CRow>
            <CRow>
                <CCol md="6">
                  <br />
                    <CInput
                      :isValid="checkIfValid('password')"
                      :value.sync="$v.form.password.$model"
                      label="Contraseña"
                      type="password"
                      placeholder=""
                      autocomplete="new-password"
                      invalidFeedback="Debe tener al menos 8 caracteres y teniendo al menos un número, una mayúscula y una minúscula."
                  />
                </CCol>
                <CCol md="6">
                  <br />
                  <CInput
                    :isValid="checkIfValid('confirmPassword')"
                    :value.sync="$v.form.confirmPassword.$model"
                    label="Confirmar Contraseña"
                    type="password"
                    placeholder=""
                    autocomplete="new-password"
                    invalidFeedback="Las contraseñas no coinciden."
                />
                </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, email, sameAs, helpers, minValue } from "vuelidate/lib/validators"
import ws from '../../services/kams';
import providers_ws from '../../services/providers';
import store from '../../store'

export default {
  name: 'KamModal',
  props: {

  },
  data () {
    return {
      showModal: false,
      title: "Nuevo Kam",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'actions', label: '', class: 'actions' }
      ],
      link: '',
      item: false,
      kams: [],
      kamsOptions: [],
      providers: [],
      providersOptions: []
    }
  },
  mounted: async function() {
    let response = await providers_ws.get(); 

    if(response.type == "success"){
      this.providers = response.data;

      this.providersOptions = await this.$parseSelectOptionsOrdered(this.providers, "id", "name", [{value: '0', label: 'NO DEFINIDO'}]);
    }
  },
  methods: {
    storeModal () {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Kam';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
          id: 0,
          provider_id: 0,
          name: '',
          email: '',
          password: '',
          confirmPassword: ''
      }
    },
    updateModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Kam';
      this.isEdit = true;
      this.submitted = false;

      this.item = item;

      if(item.user.api_token){
        this.link = "https://app.kpibonus.com/#/"+item.user.api_token+"/login-link";
      }
      else{
        this.link = false;
      }

      this.form = {
          id: item.id,
          provider_id: item.provider_id,
          name: item.name,
          email: item.user.email ? item.user.email : '',
          password: '********',
          confirmPassword: '********'
      };
    },
    store () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        if(this.form.id > 0){
          this.$emit("update", this.form );
        }
        else{
          this.$emit("store", this.form );
        }

        this.closeModal();
      }
    },
    async generate () {
      let params = {
          id: this.form.id,
          provider_id: this.form.provider_id,
          name: this.form.name
      };

      let response = await ws.generateLink(this.form);
      
      if(response.type == "success"){
        this.link = response.data.link;
        this.form.email = response.data.user.email;
        this.form.password = '12345678';

        this.$emit("update", this.form );
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          provider_id: 0,
          name: '',
          email: '',
          password: '**********',
          confirmPassword: '**********'
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    redirectLink(link){
      window.location = link;
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      provider_id: {
        required,
        minValue: minValue(1)
      },
      email: {
        required,
        minLength: minLength(3)
      },
      password: {
        required,
        minLength: minLength(8)
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
}
</script>